export default __webpack_public_path__ + "static/media/image-cover.2c62a08c.jpeg";